module.exports = {
	"config": {
		"siteTitle": "Dash Community Blog",
		"siteDescr": "Ideas precede software; share your thoughts!",
		"siteAuthor": "Dash Community Blog",
		"siteGithubUrl": "https://github.com/dashcommunity",
		"siteTelegramUrl": "https://telegram.me/DashDigitalCash",
		"siteTwitterUrl": "https://twitter.com/dashpay",
		"siteSlackUrl": "http://dash-nation-invite.herokuapp.com/",
		"siteYoutubeUrl": "http://www.youtube.com/c/DashOrg",
		"siteRedditUrl": "https://www.reddit.com/r/dashpay",
		"googleAnalyticsId": "",
		"linkPrefix": "/blog"
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx",
				"absolute": "/Users/Rion/code/playground/gatsby/blog/_template.jsx",
				"isAbsolute": false
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md",
				"absolute": "/Users/Rion/code/playground/gatsby/blog/404.md",
				"isAbsolute": false
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"path": "/404.html",
				"layout": "page"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles",
				"base": "_html-template.md",
				"ext": "md",
				"name": "_html-template",
				"extname": ".md",
				"basename": "_html-template.md",
				"dirname": "articles",
				"stem": "_html-template",
				"path": "articles/_html-template.md",
				"absolute": "/Users/Rion/code/playground/gatsby/blog/articles/_html-template.md",
				"isAbsolute": false
			},
			"requirePath": "articles/_html-template.md",
			"data": {
				"author": "First Last",
				"title": "Your Snazzy Title",
				"date": "2016-11-23T08:30:00.000Z",
				"layout": "post",
				"path": "/your-snazzy-title/",
				"category": "Some tags | Separated by | Pipes",
				"description": "Some sentences describing the overall gist of your entry.  You can just put the first paragraph or few sentences of your post here if you want."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles",
				"base": "_markdown-template.md",
				"ext": "md",
				"name": "_markdown-template",
				"extname": ".md",
				"basename": "_markdown-template.md",
				"dirname": "articles",
				"stem": "_markdown-template",
				"path": "articles/_markdown-template.md",
				"absolute": "/Users/Rion/code/playground/gatsby/blog/articles/_markdown-template.md",
				"isAbsolute": false
			},
			"requirePath": "articles/_markdown-template.md",
			"data": {
				"author": "First Last",
				"title": "Your Snazzy Title",
				"date": "2016-11-23T08:30:00.000Z",
				"layout": "post",
				"path": "/your-snazzy-title/",
				"category": "Some tags | Separated by | Pipes",
				"description": "Some sentences describing the overall gist of your entry.  You can just put the first paragraph or few sentences of your post here if you want."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2016-10-15-shift-to-decentralization",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2016-10-15-shift-to-decentralization",
				"stem": "index",
				"path": "articles/2016-10-15-shift-to-decentralization/index.md",
				"absolute": "/Users/Rion/code/playground/gatsby/blog/articles/2016-10-15-shift-to-decentralization/index.md",
				"isAbsolute": false
			},
			"requirePath": "articles/2016-10-15-shift-to-decentralization/index.md",
			"path": "/shift-to-decentralization/",
			"data": {
				"author": "Rion Gull",
				"title": "The Shift to Decentralization",
				"date": "2016-10-15T13:24:00.000Z",
				"layout": "post",
				"path": "/shift-to-decentralization/",
				"category": "Decentralization",
				"description": "Dash is centralized.  Contrary to popular belief, every cryptocurrency starts out centralized.  Satoshi's project started as such, Evan's subsequent improvements started out as such, and indeed, every innovation starts out as such."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2016-11-08-get-dash-to-drive",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2016-11-08-get-dash-to-drive",
				"stem": "index",
				"path": "articles/2016-11-08-get-dash-to-drive/index.md",
				"absolute": "/Users/Rion/code/playground/gatsby/blog/articles/2016-11-08-get-dash-to-drive/index.md",
				"isAbsolute": false
			},
			"requirePath": "articles/2016-11-08-get-dash-to-drive/index.md",
			"path": "/get-dash-to-drive/",
			"data": {
				"author": "Pete Eyre",
				"title": "Get Dash to Drive",
				"date": "2016-11-08T00:00:00.000Z",
				"layout": "post",
				"path": "/get-dash-to-drive/",
				"category": "Driving",
				"description": "Being the behind-the-scenes guy at DASH: Detailed, I do my best to inform folks about Dash. At least in person, such conversations are often kicked-off when someone inquires about how I spend my time. Or what my Dash t-shirt references."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2016-11-10-dash-and-society-as-microservices",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2016-11-10-dash-and-society-as-microservices",
				"stem": "index",
				"path": "articles/2016-11-10-dash-and-society-as-microservices/index.md",
				"absolute": "/Users/Rion/code/playground/gatsby/blog/articles/2016-11-10-dash-and-society-as-microservices/index.md",
				"isAbsolute": false
			},
			"requirePath": "articles/2016-11-10-dash-and-society-as-microservices/index.md",
			"path": "/dash-and-society-as-microservices/",
			"data": {
				"author": "Donnie Brandt",
				"title": "Dash And Society As Microservices",
				"date": "2016-11-10T00:00:00.000Z",
				"layout": "post",
				"path": "/dash-and-society-as-microservices/",
				"category": "Microservices",
				"description": "There is a good chance that you, dear reader, are not a software architect, so the term 'microservice', heck, even 'Dash' may not mean much to you. Keep reading and I will explain these terms and why they matter."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2016-11-11-iohk-dash-governance-review",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2016-11-11-iohk-dash-governance-review",
				"stem": "index",
				"path": "articles/2016-11-11-iohk-dash-governance-review/index.md",
				"absolute": "/Users/Rion/code/playground/gatsby/blog/articles/2016-11-11-iohk-dash-governance-review/index.md",
				"isAbsolute": false
			},
			"requirePath": "articles/2016-11-11-iohk-dash-governance-review/index.md",
			"path": "/iohk-dash-governance-review/",
			"data": {
				"author": "Rion Gull",
				"title": "IOHK Dash Governance Review",
				"date": "2016-11-11T00:00:00.000Z",
				"layout": "post",
				"path": "/iohk-dash-governance-review/",
				"category": "Governance",
				"description": "Charles Hoskinson and the Veritas Team of Input Output HK have released a research report entitled Dash Governance System: Analysis and Suggestions for Improvement."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2017-01-20-why-i-love-dash",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2017-01-20-why-i-love-dash",
				"stem": "index",
				"path": "articles/2017-01-20-why-i-love-dash/index.md",
				"absolute": "/Users/Rion/code/playground/gatsby/blog/articles/2017-01-20-why-i-love-dash/index.md",
				"isAbsolute": false
			},
			"requirePath": "articles/2017-01-20-why-i-love-dash/index.md",
			"path": "/why-i-love-dash/",
			"data": {
				"author": "Satoshi Nakamoto",
				"title": "Why I Love Dash",
				"date": "2017-01-20T14:30:00.000Z",
				"layout": "post",
				"path": "/why-i-love-dash/",
				"description": "first bit of article"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/drafts",
				"base": "README.md",
				"ext": "md",
				"name": "README",
				"extname": ".md",
				"basename": "README.md",
				"dirname": "articles/drafts",
				"stem": "README",
				"path": "articles/drafts/README.md",
				"absolute": "/Users/Rion/code/playground/gatsby/blog/articles/drafts/README.md",
				"isAbsolute": false
			},
			"requirePath": "articles/drafts/README.md",
			"path": "/articles/drafts/README/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "compose.js",
				"ext": "js",
				"name": "compose",
				"extname": ".js",
				"basename": "compose.js",
				"dirname": "",
				"stem": "compose",
				"path": "compose.js",
				"absolute": "/Users/Rion/code/playground/gatsby/blog/compose.js",
				"isAbsolute": false
			},
			"requirePath": "compose.js",
			"path": "/compose/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "",
				"stem": "index",
				"path": "index.jsx",
				"absolute": "/Users/Rion/code/playground/gatsby/blog/index.jsx",
				"isAbsolute": false
			},
			"requirePath": "index.jsx",
			"path": "/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "pages/about",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pages/about",
				"stem": "index",
				"path": "pages/about/index.md",
				"absolute": "/Users/Rion/code/playground/gatsby/blog/pages/about/index.md",
				"isAbsolute": false
			},
			"requirePath": "pages/about/index.md",
			"path": "/about/",
			"data": {
				"title": "Dash Community Blog",
				"layout": "page",
				"path": "/about"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "pages/compose",
				"base": "data.json",
				"ext": "json",
				"name": "data",
				"extname": ".json",
				"basename": "data.json",
				"dirname": "pages/compose",
				"stem": "data",
				"path": "pages/compose/data.json",
				"absolute": "/Users/Rion/code/playground/gatsby/blog/pages/compose/data.json",
				"isAbsolute": false
			},
			"requirePath": "pages/compose/data.json",
			"path": "/pages/compose/data/",
			"data": {}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 378
// module chunks = 0